import { App, KernelRouteEndpoint, KernelRoute } from "../../../kernel/kernel";
import raf from "raf";
import RouterSessionManagement from "controllers/router-session-management/index";

/**
 * Login route
 *
 * @extends KernelRoute
 */
class FormRoute extends KernelRoute {

    form () {
        const onSuccess = formData => {
            let location = "#form?referenceNumber=" + this.parsedParams.referenceNumber;
            let notAcknowledged = "not-acknowledged" === formData.status;
            let completed = "completed" === formData.status;
            console.log(formData)

            if (null != this.parsedParams.token) {
                return window.location = `#form?referenceNumber=${this.parsedParams.referenceNumber}&token=${this.parsedParams.token}`;
            }

            if (notAcknowledged) {
                System.import("./welcome").then(View => {
                    const view = new View.default({
                        params: this.parsedParams,
                        formData: formData,
                        preview: false
                    });
                    raf(_ => App.contentRegion.show(view));
                });
            }
            
            if (!notAcknowledged && completed) {
                location = "#completed";
            }

            if (!notAcknowledged) {
                window.location = location;
            }
        };

        let onFail = function(){
            window.location = "#not-found";
        }

        this.manager.obtainForm(this.parsedParams.referenceNumber, onSuccess, onFail);
    }

    preview () {
        const onSuccess = config => {
            const formData = {
                issuedBy: "John Doe",
                presets: { configuration: config }
            };
            System.import("./welcome").then(View => {
                const view = new View.default({
                    params: this.parsedParams,
                    formData,
                    preview: true
                });
                raf(_ => App.contentRegion.show(view));
            });
        };

        let onFail = function(){
            window.location.assign("#not-found");
        }

        this.manager.obtainConfig(this.parsedParams.preview).then(config => onSuccess(config)).catch(err => onFail());
    }

    /**
     * When the user hits the index page, show the index page
     */
    @KernelRouteEndpoint("/welcome(/)")
    welcomeRoute (params) {
        this.parsedParams = this.parseQueryString(params);
        this.manager = new RouterSessionManagement();

        if (this.parsedParams.preview != null) {
            this.preview();
        } else {
            this.form();
        }

        
    }

}

export default FormRoute;



// WEBPACK FOOTER //
// ./public/domain/views/welcome/welcome.route.js